import React from 'react'

// components
import {
  CRow,
} from '@coreui/react-pro'
import FormTextInput from '../general-input-form/FormTextInput'
import FormPhoneNumber from '../general-input-form/FormPhoneNumber'

const AppForm = ({
  values,
  handleChange,
  errors,
  countryOptions,
  country,
  setCountry,
  handleSelectCountry
}) => {
  return (
    <>
      <CRow className="mb-4">
        <FormTextInput 
          id='contact_profile_name'
          name='contact_profile_name'
          colSize='6'
          inputLabel='Profile Name'
          className='mb-3'
          placeholder='Input profile name...'
          value={values.contact_profile_name}
          handleTextInput={handleChange}
          feedbackInvalid={errors.contact_profile_name}
          invalid={errors.contact_profile_name}
        />
        <FormTextInput 
          id='contact_company_name'
          name='contact_company_name'
          colSize='6'
          inputLabel='Company Name'
          className='mb-3'
          placeholder='Input company name...'
          value={values.contact_company_name}
          handleTextInput={handleChange}
          feedbackInvalid={errors.contact_company_name}
          invalid={errors.contact_company_name}
        />
        <FormPhoneNumber
          colSize='6'
          inputLabel='Phone Number'
          placeholder='Input whatsapp number...'
          className='mb-3'
          countryOptions={countryOptions}
          country={country}
          setCountry={setCountry}
          value={values}
          handlePhoneNumber={handleChange}
          handlePhoneCountry={handleSelectCountry}
          errors={errors}
          inputIdNumber='contact_wa_id'
          inputIdCountry='contact_phone_code'
        />
      </CRow>
    </>
  )
}

export default AppForm